import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BookOpenCheck, FileSearch, FlaskConical, Wand2 } from 'lucide-react';
import SEO from '../components/SEO';
import { Section } from '../components/Section';

export default function TesixPeruLandingPage() {
  return (
    <>
      <SEO
        title="Neuralia369Tesix Perú | Revisión de tesis, metodología y WordLab"
        description="Neuralia369Tesix Perú ayuda a organizar tesis, revisar metodología, trabajar observaciones y operar WordLab con acompañamiento académico y trazabilidad."
        path="/neuralia369tesix-peru"
        keywords="tesis Perú, revisión de tesis Perú, metodología tesis Perú, WordLab tesis, Neuralia369Tesix Perú"
      />
      <div className="min-h-screen bg-background pt-24 pb-20" data-testid="tesix-peru-landing-page">
        <Section>
          <div className="max-w-6xl mx-auto grid gap-10 xl:grid-cols-[1.05fr_0.95fr]">
            <div>
              <p className="editorial-kicker mb-4">Neuralia369Tesix · Perú</p>
              <h1>Revisión de tesis, metodología y WordLab para proyectos académicos en <span className="gradient-text">Perú</span></h1>
              <p className="mt-6 text-lg text-text-body">Una línea operativa para trabajar capítulos, observaciones por universidad, metodología, fuentes y revisión de entregables desde un único espacio.</p>
              <div className="mt-8 flex flex-wrap gap-4">
                <Link to="/contacto" className="btn-primary" data-testid="tesix-peru-contact-cta">Quiero información<ArrowRight className="w-5 h-5" /></Link>
                <Link to="/agenda" className="btn-secondary" data-testid="tesix-peru-agenda-cta">Reservar llamada</Link>
              </div>
            </div>
            <div className="grid gap-4 md:grid-cols-2">
              {[
                { icon: FileSearch, title: 'Diagnóstico inicial', copy: 'Lectura del avance y definición de siguiente ruta de trabajo.' },
                { icon: FlaskConical, title: 'Metodología', copy: 'Diseño y ajuste metodológico con un flujo más claro.' },
                { icon: Wand2, title: 'WordLab', copy: 'Editor operativo para reescribir y revisar por secciones.' },
                { icon: BookOpenCheck, title: 'Observaciones', copy: 'Tablero para trabajar correcciones por universidad y capítulo.' },
              ].map(({ icon: Icon, title, copy }) => (
                <div key={title} className="glass-card tracing-panel p-6" data-testid={`tesix-peru-card-${title}`}>
                  <Icon className="w-6 h-6 text-primary" />
                  <p className="mt-4 text-lg font-semibold text-text-heading">{title}</p>
                  <p className="mt-3 text-sm text-text-body">{copy}</p>
                </div>
              ))}
            </div>
          </div>
        </Section>
      </div>
    </>
  );
}